import { general_states } from "../../utils/staticEnums";
import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const STOCK_BASE = "/shipments";
const buildUrl = (endpoint) => STOCK_BASE + endpoint;

const shipmentsApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        getShipments: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'Shipments' }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getProducts', 'Shipments')
        }),
        getShipment: builder.query({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'GET',
            }),
            // The endpoint wraps the record as { shipment }, so unwrap it to the shipment itself.
            transformResponse: (response) => response?.shipment ?? response,
            providesTags: () => [{ type: 'ShipmentsSingle' }],
        }),
        getPickingSlip: builder.mutation({
            query: id => ({
                url: buildUrl(`/${id}/pickingslip`),
                method: 'GET',
                responseHandler: async (response) => {
                    const text = await response.text();
                    try {
                        return JSON.parse(text);
                    } catch (e) {
                        // If parsing fails, return the text as-is wrapped in an object
                        return { data: text };
                    }
                },
            }),
            providesTags: () => [{ type: 'ShipmentLabel' }],
        }),
        updateShipment: builder.mutation({
            query: shipmentInfo => ({
                url: buildUrl(`/${shipmentInfo.id}`),
                method: 'PUT',
                body: shipmentInfo,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'OrderShipments'}],
        }),
        bulkUpdateShipments: builder.mutation({
            query: shipmentInfo => ({
                url: buildUrl(`/bulkupdate`),
                method: 'PUT',
                body: shipmentInfo,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'Shipments'}, {type: 'NoCostsCount'}],
        }),
        createRelationLabel: builder.mutation({
            query: body => ({
                url: buildUrl(`/relation-label`),
                method: 'POST',
                body,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'Shipments'}],
        }),
        exportPackagingUsage: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/packagingusage/export`),
                method: 'POST',
                body: body,
                responseHandler: async (response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }

                    const contentType = response.headers.get('content-type');

                    // JSON means either the file is ready (200 with a blobUrl) or the worker
                    // is still busy with it (202).
                    if (contentType && contentType.includes('application/json')) {
                        const jsonData = await response.json();

                        if (jsonData.blobUrl) {
                            const a = document.createElement('a');
                            a.href = jsonData.blobUrl;
                            a.download = jsonData.fileName || `packaging_export_${new Date().toISOString().split('T')[0]}.xlsx`;
                            a.target = '_blank';
                            document.body.appendChild(a);
                            a.click();
                            a.remove();

                            return { data: { success: true, message: jsonData.message, immediate: true } };
                        }

                        return { data: { success: true, processing: true, message: jsonData.message, exportId: jsonData.exportId } };
                    }

                    const blob = await response.blob();

                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `packaging_export_${new Date().toISOString().split('T')[0]}.xlsx`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);

                    return { data: { success: true, immediate: true } };
                },
            }),
        }),
    })
});

// console.log(apiSlice);
export const { 
    useGetShipmentsQuery,
    useGetPickingSlipMutation,
    useUpdateShipmentMutation,
    useBulkUpdateShipmentsMutation,
    useCreateRelationLabelMutation,
    useExportPackagingUsageMutation,
    useGetShipmentQuery
} = shipmentsApiSlice;
